
import { defineComponent } from 'vue'

// components
import Pagination from '@/common/components/UI/Pagination/index.vue'

export default defineComponent({
    components: {
        pagination: Pagination,
    },
    props: {
        totalPages: {
            type: Number,
            default: 1,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        totalItems: {
            type: Number,
            default: 20,
        },
        limit: {
            type: Number,
            default: 20,
        },
    },
    emits: ['change'],
    setup(_, { emit }) {
        const emitChange = (page: number) => {
            emit('change', page)
        }

        return { emitChange }
    },
})
